module.exports = __webpack_public_path__ + "static/img/fun3.ab97e1b1.png";